module.exports = __webpack_public_path__ + "static/media/ukwaba-logo.00c0809a.png";